import React, { useState } from 'react';
import Faq01 from '../../../assets/images/home_page_7/faq/01.png'

const Faq = () => {
    const [openIndex, setOpenIndex] = useState(0);

    const faqItems = [
        {
            id: 1,
            question: "The power of applied intelligence",
            answer: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that."
        },
        {
            id: 2,
            question: "We take a closer look",
            answer: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that."
        },
        {
            id: 3,
            question: "Another important aspect",
            answer: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that."
        }
    ];

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <section id="faq" className="faq-main-block">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <div className="faq-img">
                                <img
                                    src={Faq01}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div className="col-lg-5 offset-lg-1 col-md-6 offset-md-0">
                            <div className="faq-block">
                                <h2 className="section-heading">
                                    Your toolkit for business creativity
                                </h2>
                                <div className="accordion" id="accordionExample">
                                    {faqItems.map((item, index) => (
                                        <div className="accordion-item" key={item.id}>
                                            <h4 className="accordion-header">
                                                <button
                                                    className={`accordion-button ${openIndex === index ? '' : 'collapsed'}`}
                                                    type="button"
                                                    onClick={() => handleToggle(index)}
                                                    aria-expanded={openIndex === index}
                                                >
                                                    {item.question}
                                                </button>
                                            </h4>
                                            <div
                                                className={`accordion-collapse collapse ${openIndex === index ? 'show' : ''}`}
                                            >
                                                <div className="accordion-body">
                                                    <p>{item.answer}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Faq;